import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '../components/errorPage.vue'
import ContractStandard from '../components/contractStandard.vue'
Vue.use(Router)


const routes = [
  // 错误页
  {
    path: '/errorPage',
    name: 'errorPage',
    component: ErrorPage,
  },
  // 制式合同
  {
    path: '/contractStandard',
    name: 'contractStandard',
    component: ContractStandard
  },
  // 非制式合同
  {
    path: '/contractLock',
    name: 'contractLock',
    component: () => import(/* webpackChunkName: "about" */ '../components/contractLock.vue')
  },
  // 合同预览
  {
    path: '/contractPreview',
    name: 'contractPreview',
    component: () => import(/* webpackChunkName: "about" */ '../components/contractPreview.vue')
  },
  // 合同签署
  {
    path: '/contractSign',
    name: 'contractSign',
    component: () => import(/* webpackChunkName: "about" */ '../components/contractSign.vue')
  },
  // 特批管理
  {
    path: '/specialManage',
    name: 'specialManage',
    component: () => import(/* webpackChunkName: "about" */ '../components/specialManage.vue')
  },
  //修改领导
  {
    path: '/changeLeader',
    name: 'changeLeader',
    component: () => import(/* webpackChunkName: "about" */ '../components/changeLeader.vue')
  },
  // 特批管理(新)
  {
    path: '/newSpecialManage',
    name: 'newSpecialManage',
    component: () => import(/* webpackChunkName: "about" */ '../components/newSpecialManage.vue')
  },
  //契约锁配置(新)
  {
    path: '/newContractConfiguration',
    name: 'newContractConfiguration',
    component: () => import(/* webpackChunkName: "about" */ '../components/newContractConfiguration.vue')
  },
  //   虚拟资产
  {
    path: '/virtualAssets',
    name: 'virtualAssets',
    component: () => import(/* webpackChunkName: "about" */ '../components/virtualAssets.vue')
  },
    //   契约锁配置(最新 2026-3-26)
  {
    path: '/createContract',
    name: 'createContract',
    component: () => import(/* webpackChunkName: "about" */ '../components/createContract.vue')
  },
  //   绿通起草合同
  {
    path: '/contractFastTrackDraft',
    name: 'ContractFastTrackDraft',
    component: () => import(/* webpackChunkName: "about" */ '../components/contractFastTrackDraft.vue')
  },
]

const router = new Router({
  routes: routes
})

export default router
